var map = {
	"./assembleDetail.js": "1d9f",
	"./assemblePage.js": "5979",
	"./myAssemble.js": "8f83",
	"./orderConfirm.js": "07ef",
	"./productDetail.js": "09b9",
	"./testModule.js": "f640"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8665";